export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8173.8e9cb7ee.jpg";